/**
 * @param {string} string
 * @returns {string}
 */
function kebabCase (string) {
  return string && string
    .toString()
    .trim()
    .replace(/([A-Z])([A-Z])/g, '$1-$2')
    .replace(/([a-z])([A-Z])/g, '$1-$2')
    .replace(/[\s_]+/g, '-')
    .replace(/-{2,}/g, m => '-')
    .toLowerCase()
}

module.exports = { kebabCase }
